/**
 * Footer Component - My Riad Manager
 * Footer global avec branding
 */

import React from 'react';
import { BRANDING } from '../config/branding';
import { ExternalLink } from 'lucide-react';

export default function Footer({ variant = 'default', className = '' }) {
  if (variant === 'minimal') {
    return (
      <footer className={`text-center text-xs text-muted-foreground py-2 ${className}`}>
        {BRANDING.copyright} · <a href={BRANDING.url} target="_blank" rel="noopener noreferrer" className="hover:text-primary">{BRANDING.domain}</a>
      </footer>
    );
  }

  return (
    <footer className={`border-t border-slate-200 bg-slate-50 py-4 ${className}`} data-testid="app-footer">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <img src={BRANDING.logo} alt={BRANDING.name} className="w-5 h-5" />
            <span>{BRANDING.copyright}</span>
          </div>
          <a 
            href={BRANDING.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-1 hover:text-primary transition-colors"
          >
            {BRANDING.domain}
            <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </footer>
  );
}
